import { useState } from 'react'
import BedManagement from './BedManagement'
import BedAllocation from '../allocation/BedAllocation'
import '../bms.scss'
import { allocation } from '../modals'
import { Box } from '@mui/material'

const BedOverview = () => {
  const [route] = useState('bedManagement')

  return (
    <>
      <Box height={'99%'}>
        {route === allocation.bedManagementRoute ? (
          <BedManagement />
        ) : (
          <BedAllocation />
        )}
      </Box>
    </>
  )
}

export default BedOverview
